'use client';
import { InstallAppBanner } from '~/app/_components/install-app-banner';
import { Center } from '@styled-system/jsx';
import { useLocalState } from './use-local-state';

export const InstallAppBannerContainer = () => {
  const { handleOnClickOpenInApp, link } = useLocalState();
  return (
    <Center w="100%" backgroundColor="surface_secondary">
      <InstallAppBanner
        display={{
          base: 'none',
          lgDown: 'block',
        }}
        width="100%"
        maxW="400px"
        openAppClick={handleOnClickOpenInApp}
        link={link}
      />
    </Center>
  );
};
